import React from "react";
import { Box } from "@material-ui/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface ReferenceImageThumbnailProps {
  imageUrl: string;
}

const ReferenceImageThumbnail: React.FC<ReferenceImageThumbnailProps> = ({ imageUrl }) => {
  const { t } = useTranslation();

  return (
    <ThumbnailContainer>
      <ThumbnailImage src={imageUrl} alt={t("imageGenerator.referenceImageAlt")} />
    </ThumbnailContainer>
  );
};

export default ReferenceImageThumbnail;

const ThumbnailContainer = styled(Box)`
  position: relative;
  display: inline-block;
  margin-top: 8px;
  margin-bottom: 8px;
`;

const ThumbnailImage = styled.img`
  max-height: 80px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: block;
`;
